import { ChevronLeftIcon, ChevronRightIcon, MinusIcon, PlusIcon } from 'lucide-react'
import { Button, IconButton } from '@rentflowdev/ui'

interface PaginationBarProps {
	page:        number
	totalPages:  number
	zoom:        number
	onPrev?:     () => void
	onNext?:     () => void
	onZoomIn?:   () => void
	onZoomOut?:  () => void
}

/**
 * Bottom pagination bar — page navigation on the left, zoom controls on the right.
 * Matches the PDF-viewer-style footer.
 */
export function PaginationBar({ page, totalPages, zoom, onPrev, onNext, onZoomIn, onZoomOut }: PaginationBarProps) {
	return (
		<div className="flex items-center justify-between border-t border-(--color-border) bg-(--color-card) px-6 py-3">
			<div className="flex items-center gap-1">
				<IconButton variant="ghost" size="sm" aria-label="Previous page" onClick={onPrev} disabled={page <= 1}>
					<ChevronLeftIcon className="size-4" />
				</IconButton>
				<Button variant="secondary" size="sm" disabled className="pointer-events-none">
					Стр. {page} / {totalPages}
				</Button>
				<IconButton variant="ghost" size="sm" aria-label="Next page" onClick={onNext} disabled={page >= totalPages}>
					<ChevronRightIcon className="size-4" />
				</IconButton>
			</div>
			<div className="flex items-center gap-1 text-sm text-(--color-muted-foreground)">
				<IconButton variant="ghost" size="sm" aria-label="Zoom out" onClick={onZoomOut}>
					<MinusIcon className="size-4" />
				</IconButton>
				<span className="min-w-12 text-center">{zoom}%</span>
				<IconButton variant="ghost" size="sm" aria-label="Zoom in" onClick={onZoomIn}>
					<PlusIcon className="size-4" />
				</IconButton>
			</div>
		</div>
	)
}
